export const LANDING_PAGE_LOGO = 1;
export const NAVBAR_LOGO = 2;
